import React, { useEffect, useState } from "react";
import { Dialog, Stack, Toolbar } from "@mui/material";
import { useAuth } from "./useAuth.jsx";
import CardCommon from "./CardCommon.jsx";



import { Box, Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import StarIcon from "@mui/icons-material/StarBorder";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material";
import { InputNumber } from "../Components/Inputs/Input_Number.jsx";
import { CheckoutForm } from "../Components/StripeCheckout_custom.jsx";
import { v4 as uuidv4 } from "uuid";


import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ftchPlus, getOptions, postOptions } from "./Account_urls.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { API_stripe } from "./api.jsx";
import DialogDelete from "../Components/DialogDelete.jsx";
import { myOwnFPColor } from "./GridRenderers.jsx";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

const g_STRIPE_KEY = process.env.REACT_APP_STRIPE_TEST;


const stripePromise = loadStripe(g_STRIPE_KEY);


const PricingList = styled("ul")({
  margin: 0,
  padding: 0,
  listStyle: "none",
});

const tiers = [
  {
    stripeID: "",
    title: "Limited",
    price: "Free",
    period: "always",
    description: [
      "1 Client",
      "Standard tools",
      "No Tax Calculations",
      "No CPP/OAS Calculations",
      "Access shared clients",
      "Access public clients",
    ],
    buttonText: "",
    buttonVariant: "outlined",
    buttonDisabled: true,
  },
  {
    stripeID: "price_1N5EEoB9O8Ra1NWE6zXdvvGK",
    title: "Personal",
    price: "40",
    period: "year",
    description: [
      "5 Clients",
      "Standard accounts",
      "Government Benefits",
      "Tax treatment",
      "Unlimited scenario runs",
      "",

    ],
    buttonText: "Subscribe",
    buttonVariant: "contained",
    buttonDisabled: false,

  },
];

const mo_tiers = [
  {
    stripeID: "",
    title: "Personal 10",
    price: "75",
    period: "year",
    description: [
      "10 Clients",
    ],
    buttonText: "Subscribe",
    buttonVariant: "contained",
    buttonDisabled: false,

  },
  // {
  //   stripeID: "",
  //   title: "Personal 15",
  //   price: "110",
  //   period: "year",
  //   description: [
  //     "15 Clients",
  //   ],
  //   buttonText: "Subscribe",
  //   buttonVariant: "contained",
  //   buttonDisabled: false,

  // },
  {
    stripeID: "",
    title: "Unlimited",
    price: "140",
    period: "year",
    description: [
      "Unlimited Clients",
    ],
    buttonText: "Subscribe",
    buttonVariant: "contained",
    buttonDisabled: false,
  },

];




const addCurrency = (price) => {
  if (price !== "Free") {
    return "CA $ " + price
  }
  return price
}

const addPeriod = (period) => {
  if (period !== "") {
    return " / " + period
  }
  return ""
}



const PricingCard = ({ tier, subscription, onSubscription, lines }) => {
  return (
    <Box sx={{ display: "flex", my: 2, p: 2, border: subscription === tier.title ? "4px solid #7fc3e5" : "1px light grey" }}       >

      <Card sx={{
        width: 330,
        height: 100 + 100 + 10 + lines * 27.5,
      }}>

        <CardHeader
          title={tier.title}
          subheader={tier.subheader}
          titleTypographyProps={{ align: "center" }}
          // action={tier.title === "Pro" ? <StarIcon /> : null}
          subheaderTypographyProps={{
            align: "center",
          }}
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[200]
                : theme.palette.grey[700],
          }}
        />
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "baseline",
              mb: 2,
            }}
          >
            <Typography component="h2" variant="h4" color="text.primary">
              <strong>{addCurrency(tier.price)}</strong>
            </Typography>
            <Typography mb={3} variant="h6" color="text.secondary">
              {addPeriod(tier.period)}
            </Typography>
          </Box>
          <PricingList>
            {tier.description.map((line, i) => (

              <Stack key={"pc-st-li:" + i} direction="row" sx={{ mx: 10 }} spacing={2}>
                {line !== "" && (
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    size="sm"
                    color={myOwnFPColor} />
                )}
                <Stack sx={{}}>
                  <Typography
                    sx={{ mt: -2 }}
                    //component="li"
                    variant="subtitle1"
                    align="left"
                    height={30}
                    gutterBottom={true}
                  >
                    {line}
                  </Typography>
                </Stack>
              </Stack>
            ))}
          </PricingList>
        </CardContent>
        <CardActions >
          {tier.buttonText !== "" && (
            <Button fullWidth
              variant={tier.buttonVariant}
              // disabled={tier.buttonDisabled}
              disabled={true}
              onClick={() => { onSubscription(tier) }}>
              {tier.buttonText}
            </Button>
          )}
        </CardActions>
      </Card>
    </Box>



  )
}


const PricingTable = ({ tiers, subscription, count, onSubscription }) => {
  const theme = useTheme();




  return (
    <Container maxWidth="true" component="main">
      <Stack direction="row" spacing={10}>
        {/* <Grid container spacing={5} alignItems="flex-end"> */}
        {
          tiers.map((tier) => (
            <PricingCard
              key={tier.title}
              tier={tier}
              subscription={subscription}
              onSubscription={onSubscription}
              lines={Math.max(...tiers.map(tier => tier.description.length), 0)}
            />
          ))}
      </Stack>
    </Container >
  );
}

const Subscribe = ({ open, onClose, subscription, count }) => {
  const [quantity, setQuantity] = useState(count)
  const [errmsg, setErrmsg] = useState("")
  const [diaDelete, setDiaDelete] = useState(false)
  const [subscriptionTier, setSubscriptionTier] = useState(null)


  console.log(subscription)
  console.log(count)
  const { subuuid_r, email_r } = useAuth();

  const onSubscribe = (tier) => {
    console.log(tier)
    setSubscriptionTier(tier)

  }

  const cancelSubscription = (tier) => {
    setDiaDelete(true)
  }

  const doCancelSubscription = (tier) => {

    console.log("cancel subscription")

    // should create a little dialog to confirm we want to cancel


    let url = API_stripe + "/subscription/delete"
    let req = postOptions
    //req.body = JSON.stringify({ ProductPriceId: tier.stripeID })

    ftchPlus(url, req)
      .then((json) => {
        // should create a little dialog to confirm cancellation happened
        onClose()
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      })



  }
  const myClose = () => {
    setSubscriptionTier(null);
    setErrmsg("");
    onClose()
  }




  useEffect(() => {
    setErrmsg("")

  }, [])


  const premiumBody = () => {
    return (
      "Optimizers<br/>Business Accounts<br/><br/><br/>$140/yr"
    )
  }
  const professionalBody = () => {
    return (
      "Custom PDF reports<br/>Export<br/>Insurance<br/><br/>$190/yr"
    )
  }
  // const StripePriceTable = () => {
  //   // Paste the stripe-pricing-table snippet in your React component
  //   console.log(subuuid_r.current)
  //   return (
  //     <stripe-pricing-table
  //       pricing-table-id="prctbl_1N5EI7B9O8Ra1NWEylV9eLua"
  //       publishable-key="pk_test_51N4UhCB9O8Ra1NWExVfkIvSmmfpLripyM6rfvufjcnQrPRbehjpWFMIxDUbH83KhnxlrkUkd3LwQeLhGfoj673Oe00DK1vX3Uj"
  //       client-reference-id={subuuid_r.current}
  //       customer-email={email_r.current}
  //     />
  //   )
  // }

  return (
    <center>
      <Dialog
        sx={{
          overflow: "scroll",
          "& .MuiDialog-container": {
            display: "inline-flex !important",
            justifyContent: "center",
            alignItems: "center",
            overflow: "scroll",
            // mt: 30,
            // mx: 30,
            width: "100%",
            // minWidth: 1800,

          },
        }}
        //fullWidth={true}
        width="70%"
        maxWidth="100%"
        open={open}
        onClose={() => { myClose() }}
      //disableEscapeKeyDown={true}
      >
        <Stack m={4} sx={{ justifyContent: "center" }} py={2} spacing={5}>

          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >

            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Stack direction="row">
                <Typography sx={{ justifyContent: "center" }} variant="h4">
                  Subscriptions
                </Typography>
              </Stack>
            </Box>



            <Stack direction="row" spacing={4} />
            <Button variant="contained"
              color="secondary"
              onClick={myClose}
            >
              Cancel
            </Button>
          </Box>







          <Box sx={{ width: 600 }}>
            <Typography component="h2" variant="body1">
              Each client allows for a partner/spouse.
            </Typography>
          </Box>


          <PricingTable
            key={uuidv4()}
            tiers={tiers}
            subscription={subscription}
            count={count}
            onSubscription={onSubscribe}
            lines={6}
          />
          <PricingTable
            key={uuidv4()}
            tiers={mo_tiers}
            subscription={subscription}
            count={count}
            onSubscription={onSubscribe}
            height={1}
          />

          <Stack sx={{ justifyContent: "center" }} direction="row" spacing={4}>
            {/* <Typography pt={2} variant="body1">
              Current Subscription Quantity:  {count}
            </Typography> */}
            {/* <Box sx={{ width: 100, my: 2, p: 2, border: "1px solid #7fc3e5" }}       >
              <Typography variant="body1">
                {count}
              </Typography>
            </Box> */}
            {/* <InputNumber
              label="New Quantity"
              width={100}
              value={quantity}
              min={0}
              max={5000}
              onChange={(e) => setQuantity(e.target.value)}
            /> */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
              <Button variant="contained"
                color="secondary"
                onClick={cancelSubscription}
                disabled={true}
              >
                Cancel Subscription
              </Button>
            </Box>

          </Stack>



          {/* {StripePriceTable()} */}

          {/* <Stack direction="row" spacing={2} sx={{ pr: 2 }}>
            <CardCommon title="Premium" subtitle="(coming soon)" body={premiumBody()} />
            <CardCommon title="Professional" subtitle="(TBD)" body={professionalBody()} />

          </Stack> */}
        </Stack>
        {
          subscriptionTier !== null && (
            // <CheckoutSubscription
            //   tier={subscriptionTier}
            //   quantity={quantity}
            //   onError={(errmsg) => { setSubscriptionTier(null); setErrmsg(errmsg) }}
            //   onSuccess={(msg) => { setSubscriptionTier(null); setErrmsg("") }}
            //   onClose={(msg) => { setSubscriptionTier(null); setErrmsg("") }}
            // />
            <CheckoutSession
              tier={subscriptionTier}
              quantity={quantity}
              onError={(errmsg) => { setSubscriptionTier(null); setErrmsg(errmsg); }}
              onSuccess={(msg) => { myClose() }}
              onClose={(msg) => { myClose() }}


            />
          )
        }
        <DialogDelete
          show={diaDelete}
          onClose={() => setDiaDelete(false)}
          item={"subscription"}
          onDelete={doCancelSubscription}
        />


        <ErrorBar error={errmsg} />

      </Dialog >
    </center >
  );
};

const CheckoutSubscription = ({ tier, quantity, onError, onSuccess, onClose }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [price, setPrice] = useState(0);
  const [action, setAction] = useState("");
  const [expiry, setExpiry] = useState("");
  const [renewal, setRenewal] = useState("");
  const [show, setShow] = useState(false);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };

  const createSubscription = () => {
    console.log("fetch subscription")

    let url = API_stripe + "/subscription/create"
    let req = postOptions
    let body = {
      ProductPriceId: tier.stripeID,
      OneTime: tier.stripeOneTime,
      DurationDays: tier.stripeDuration,
      Quantity: quantity,
    }
    req.body = JSON.stringify(body)

    ftchPlus(url, req)
      .then((json) => {
        setClientSecret(json.ClientSecret)
        setPrice(json.Price)
        setAction(json.Action)
        setExpiry(json.Expiry)
        setRenewal(json.Renewal)
        setShow(true)
      })
      .catch((error) => {
        console.log(error.message);
        onError(error.message)
      })

  }

  useEffect(() => {
    setShow(false)
    console.log("create subscription")
    createSubscription()
  }, [tier]);

  return (
    <>
      {clientSecret !== "" && (
        <Elements stripe={stripePromise} options={options} >
          <CheckoutForm
            tier={tier}
            quantity={quantity}
            price={price}
            action={action}
            clientSecret={clientSecret}
            expiry={expiry}
            renewal={renewal}
            show={show}
            onClose={() => { setShow(false); onClose() }}

            onError={(msg) => { onError(msg) }}
            onSuccess={(msg) => { onSuccess(msg) }}
          />
        </Elements>
      )}
    </>
  )
}


const CheckoutSession = ({ tier, quantity, onError, onSuccess, onClose }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [price, setPrice] = useState(0);
  const [action, setAction] = useState("");
  const [expiry, setExpiry] = useState("");
  const [renewal, setRenewal] = useState("");
  const [show, setShow] = useState(false);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };


  const stripeRedirect = (redirect) => {
    let req = getOptions
    console.log(redirect)
    //location.href = redirect
    window.open(redirect, "_blank")
    onSuccess('Success')
  }

  const checkoutSession = () => {

    let url = API_stripe + "/session/checkout"
    let req = postOptions
    let body = {
      ProductPriceId: tier.stripeID,
      OneTime: tier.stripeOneTime,
      DurationDays: tier.stripeDuration,
      Quantity: quantity,
    }
    req.body = JSON.stringify(body)

    ftchPlus(url, req)
      .then((json) => {
        console.log(json)
        if (json.Url) {
          stripeRedirect(json.Url)
        } else {
          onSuccess('Updated')
        }
      })
      .catch((error) => {
        console.log(error.message);
        onError(error.message)
      })

  }

  useEffect(() => {
    setShow(false)
    console.log("create subscription")
    checkoutSession()
  }, [tier]);

  return (
    <>

    </>
  )
}


export default Subscribe;
